import { useMemo, useState } from "react";
import styles from "./mortgageRepaymentResult.module.css";
import GetMonthlyPayment from "../../../helpers/monthlyPayment";
import GetTotalInterestTime from "../../../helpers/totalInterestTime";
import LeadGate from "../budget/LeadGate.jsx";
import BudgetCalculator from "../budget/BudgetCalculator.jsx";

const MortgageRepaymentResult = ({ loan, extra, year, rate }) => {
  const [showGate, setShowGate] = useState(false);
  const [showBudget, setShowBudget] = useState(false);

  const AUDollar = new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });

  const { monthlyRepayment, totalInterest } = useMemo(() => {
    const L = Number(loan) || 0;
    const Y = Number(year) || 0;
    const R = Number(rate) || 0;
    const X = Number(extra) || 0;

    if (L === 0 || Y === 0 || R === 0) {
      return { monthlyRepayment: 0, totalInterest: 0 };
    }

    const basePay = Number(GetMonthlyPayment(L, R, Y)) || 0;
    const payInterestTime = GetTotalInterestTime(L, R, Y, X) || {};
    return {
      monthlyRepayment: basePay + X,
      totalInterest: Number(payInterestTime.totalInterest) || 0,
    };
  }, [loan, year, rate, extra]);

  return (
    <div className={styles.result_view}>
      <div className="col-m-6">
        <label className={`form-label ${styles.label_main}`}>Current Monthly Payment</label>
        <div className={styles.payment}>{AUDollar.format(monthlyRepayment || 0)}</div>
      </div>

      {/* Divider above totals */}
      <hr className={styles.hr} />

      {/* Totals row — 2 columns, each label over its value */}
      <div className={styles.total_wrapper}>
        <div className={styles.total_cell}>
          <label className={`form-label ${styles.total_label}`}>Total Principal</label>
          <div className={styles.total_value}>{AUDollar.format(Number(loan) || 0)}</div>
        </div>

        <div className={styles.total_cell}>
          <label className={`form-label ${styles.total_label}`}>Total Interest</label>
          <div className={styles.total_value}>{AUDollar.format(Number(totalInterest) || 0)}</div>
        </div>
      </div>

      {/* Divider below totals */}
      <hr className={styles.hr} />

      <div className={styles.actionsRow}>
        <button
          type="button"
          className={styles.secondaryButton}
          onClick={() => setShowGate(true)}
          aria-label="Open Budget Lead Form"
        >
          Check Your Budget
        </button>

        <a
          href="https://www.mortgagematrix.com.au/apply"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkWrapper}
        >
          <button className={styles.infoButton}>
            Suggested Lenders <span className={styles.arrow}>→</span>
          </button>
        </a>
      </div>

      <div className={styles.disclaimer}><hr></hr>
        If you choose a home loan with one of our panel of lenders, your savings
        may vary based on your specific home loan.
      </div>

      {/* Lead gate → on success, open the budget calculator */}
      {showGate && !showBudget && (
        <LeadGate
          repaymentAmount={Number(monthlyRepayment) || 0}
          onSuccess={() => { setShowGate(false); setShowBudget(true); }}
          onCancel={() => setShowGate(false)}
        />
      )}

      {showBudget && (
        <BudgetCalculator
          repaymentAmount={Number(monthlyRepayment) || 0}
          onClose={() => setShowBudget(false)}
          onTalkToBroker={() => (window.location.href = "/apply")}
        />
      )}
    </div>
  );
};

export default MortgageRepaymentResult;
